import AccountingNotesComponent from './AccountingNotesComponent';

export default AccountingNotesComponent;
